import api from '@/apis/di/projectExpenseAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance, computed } from 'vue';

// Combo grid khoản chi
export const useProjectExpenseComboGrid = (comboboxDataRemote, comboboxLoadData, columnName) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onProjectExpenseComboboxLoadData = (payload, row, column, custom) => {
    let extend = [
    ];
    if (row.project_id) {
      extend.push({ Field: 'project_id', Value: row.project_id })
    }
    if (payload.columns && !payload.columns.includes('project_id')) {
      payload.columns += ',project_id';
    }
    payload.filter = extendFilter(payload.filter, extend);
    payload.sort = 'project_expense_code';
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // config columns combo
  const projectExpenseComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã khoản chi',
        dataField: 'project_expense_code',
        width: 150,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên khoản chi',
        dataField: 'project_expense_name',
        width: 450,
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      },
    ],
    displayField: 'project_expense_code',
    valueField: 'project_expense_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onProjectExpenseComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {
    projectExpenseComboConfig,
    onProjectExpenseComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
